/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/* eslint-disable sort-keys */

/*
 * While onboarding another app in cjm.js, please identify
 * if there are sharable configs among apps and if yes, then
 * create a baseConfig object and move common configs there
*/

import {Sandbox} from '@exc/core';

export const cjmAdmin = {
  base: '/cjm',
  distributionList: ['cjm-dev@adobe.com'],
  appId: 'cjm-admin',
  path: '/cjm/admin',
  sandbox: {
    history: Sandbox.HISTORY_TYPES.HISTORY,
    sources: {
      dev: 'https://localhost.corp.adobe.com:1234',
      qa: 'https://experience-qa.adobe.com/solutions/cjm-admin-app',
      stage: 'https://experience-stage.adobe.com/solutions/cjm-admin-app',
      prod: 'https://experience.adobe.com/solutions/cjm-admin-app'
    },
    ims: {
      client_id: 'cjm-admin',
      scope: 'AdobeID,openid,read_organizations,additional_info.projectedProductContext,additional_info.roles'
    }
  }
};

export const cjmMessage = {
  appId: 'cjm-message',
  distributionList: ['Grp-Content-Authoring-India'],
  path: '/cjm/message',
  sandbox: {
    history: Sandbox.HISTORY_TYPES.HISTORY,
    sources: {
      dev: 'https://localhost.corp.adobe.com:3000',
      qa: 'https://experience-qa.adobe.com/solutions/cjm-message-ui',
      stage: 'https://experience-stage.adobe.com/solutions/cjm-message-ui',
      prod: 'https://experience.adobe.com/solutions/cjm-message-ui'
    },
    ims: {
      client_id: 'cjm-message',
      scope: 'AdobeID, openid, read_organizations'
    }
  }
};
